function normalizedText(value) {
    return String(value ?? "").trim().toLowerCase();
}

export function matchingCustomerArticleCodes(hit, searchKeyword) {
    const keyword = normalizedText(searchKeyword);
    if (!keyword) return [];
    const customers = Array.isArray(hit?.cliente) ? hit.cliente : [];
    const codes = [hit?.articolo_cli, hit?.codice_cli, ...customers.map(customer => customer?.codice_cli)]
        .flat().filter(value => typeof value === "string" && normalizedText(value).includes(keyword));
    return [...new Set(codes.map(value => value.trim()))];
}

function isAssemblyArticle(hit) {
    if (hit?.tabella !== "ITMMASTER") {
        return false;
    }

    if (typeof hit.sottoprodotto_facet === "boolean") {
        return !hit.sottoprodotto_facet;
    }

    const orderby = Number(hit.orderby);
    return Number.isFinite(orderby) && orderby < 3;
}

function searchHitPriority(hit, searchKeyword) {
    const keyword = normalizedText(searchKeyword);
    const codice = normalizedText(hit?.codice);
    let priority = 0;

    if (keyword && codice.includes(keyword)) {
        priority += keyword.length;
    }

    if (hit?.tabella === "ITMMASTER") {
        priority += 100;

        if (isAssemblyArticle(hit)) {
            priority += 10;
        }

        // Una ricerca del codice completo deve continuare ad aprire direttamente
        // anche un componente, senza essere superata dall'assieme padre.
        if (keyword && codice === keyword) {
            priority += 20;
        }
        if (matchingCustomerArticleCodes(hit, keyword).some(code => normalizedText(code) === keyword)) {
            priority += 20;
        }
    }

    return priority;
}

export function rankSearchHits(hits, searchKeyword) {
    return (hits || [])
        .map((hit, originalIndex) => ({
            hit,
            originalIndex,
            priority: searchHitPriority(hit, searchKeyword),
        }))
        .sort((left, right) => right.priority - left.priority || left.originalIndex - right.originalIndex)
        .map(({ hit }) => hit);
}
